import { RouteObject } from 'react-router-dom';

import { AtiraRoute } from '../AtiraRoute';
import { AtiraRouteNotLoggedIn } from '../AtiraRouteNotLoggedIn';
import { PublicLayout } from '../PublicLayout';
import { Login } from '../loginSignup/Login';
import { ForgotPassword } from '../loginSignup/forgot-password/ForgotPassword';
import { Signup } from '../loginSignup/signup/Signup';
import { ErrorBoundary } from './RotuerError';

export const PublicRouter: RouteObject[] = [
  {
    element: <PublicLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '/',
        element: <AtiraRoute redirect="/dashboard" />,
      },
      {
        path: '/login',
        element: <AtiraRouteNotLoggedIn component={<Login />} />,
      },
      {
        path: '/signup',
        element: <AtiraRouteNotLoggedIn component={<Signup />} />,
      },
      {
        path: '/forgot-password',
        element: <AtiraRouteNotLoggedIn component={<ForgotPassword />} />,
      },
    ],
  },
];
